// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hx-j";
export var fulfillmentFormRail = "_hx-i";
export var headerTitleRow = "_hx-l";
export var orderDetailsWrapper = "_hx-g";
export var orderLinkTrigger = "_hx-2";
export var paymentInformationGrid = "_hx-q";
export var paymentSummaryColumn = "_hx-r";
export var phoneShipmentPickerButton = "_hx-e";
export var phoneShipmentPickerButtonContent = "_hx-f";
export var phoneShipmentPickerButtonWrapper = "_hx-d";
export var phoneShipmentPickerTrigger = "_hx-c";
export var shipmentContainer = "_hx-k";
export var shipmentDetailsMainPane = "_hx-h";
export var shipmentNavigationCard = "_hx-a";
export var shipmentNavigationEdgeTrigger = "_hx-6";
export var shipmentNavigationRail = "_hx-3";
export var shipmentNavigationRailEnter = "_hx-5";
export var shipmentNavigationRailHeader = "_hx-9";
export var shipmentNavigationRailOverlay = "_hx-4";
export var shipmentNavigationScrim = "_hx-7";
export var shipmentSummaryFact = "_hx-n";
export var shipmentSummaryGrid = "_hx-m";
export var shipmentSummaryMetadataRow = "_hx-o";
export var shipmentSummaryTags = "_hx-p";
export var shipmentWorkspace = "_hx-0";
export var shipmentWorkspaceBodyTablet = "_hx-8";
export var shipmentWorkspaceContent = "_hx-b";
export var shipmentWorkspaceHeader = "_hx-1";